// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9592ac54","239":"11943b5a","732":"fd5c74f8"}[chunkId] + ".chunk.js";
};